import React, { useState, useContext } from "react";
import "../styles/MobileLogin.css";
import Advert from "./Advert";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import ReCAPTCHA from "react-google-recaptcha";
import api from "../context/api";

export default function MobileLogin() {
  const { phoneNumber, setPhoneNumber } = useContext(AuthContext);
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("233");
  const [isLoading, setIsLoading] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const RECAPTCHA_SITE_KEY = "6LdktckrAAAAABh0Af2SN50Mc_f-c68_h18bwlEy";

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const sendOTP = async (formattedPhoneNumber) => {

    try {
      const response = await api.post("/otp/send", {
        senderId: "Huntex",
        phoneNumber: formattedPhoneNumber,
        countryCode: "GH",
      });

      return response.data;
    } catch (error) {
      console.error("OTP send error:", error?.response?.data || error.message);
      return { code: "9999", message: "Network error" };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phoneNumber) {
      alert("Please enter a valid mobile number.");
      return;
    }

    if (!captchaVerified) {
      alert("Please complete the reCAPTCHA.");
      return;
    }

    setIsLoading(true);

    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, "GH");

    if (!phoneNumberObj || !phoneNumberObj.isValid()) {
      alert("Invalid Phone Number. Please enter a valid phone number.");
      setIsLoading(false);
      return;
    }

    const formattedPhoneNumber = phoneNumberObj.format("E.164");

    try {
      const data = await sendOTP(formattedPhoneNumber);

      if (data.code === "0000" && data.data) {
        // Navigate immediately without alert
        navigate("/verify", {
          state: {
            prefix: data.data.prefix,
            requestId: data.data.requestId,
            phoneNumber,
            otpLength: data.data.otpLength,
          },
        });
      } else {
        alert("Failed to send OTP: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      alert("An error occurred while sending OTP. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-top"></div>
      <div className="login-box">
        <h1>Get Started With Your Mobile Number</h1>
        <p>A Verification Code Would Be Sent To Your Mobile For Confirmation</p>

        <form onSubmit={handleSubmit}>
          <div>Enter Your Phone Number</div>
          <div className="input-group">
            <select
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              <option value="233">🇬🇭 +233</option>              
            </select>
            <input
              type="tel"
              placeholder="Mobile Number (eg 054 099 0099)"
              value={phoneNumber}
              onChange={(e) => handlePhoneNumberChange(e.target.value)}
              required
            />
          </div>

          {/* Google reCAPTCHA */}
          <div className="captcha-box">
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={() => setCaptchaVerified(true)}
              onExpired={() => setCaptchaVerified(false)}
            />
          </div>

          {/* Submit */}
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Processing..." : "Proceed"}
          </button>
        </form>

        {/* Links */}
        <div className="links">
          <a href="#" onClick={() => navigate('/password-reset')}>Forgot Password</a>
          <span>
            having an account? <a href="#" onClick={() => navigate('/login')}>Login</a>
          </span>
        </div>

        <p className="support-text">
          Having a problem loggin in? <a href="#" >Contact support</a>
        </p>
      </div>
      <div style={{ marginTop: "90px", width: "100%" }}>
        <Advert />
      </div>
    </div>
  );
}
